<template>
  <div class="card">
    <h2>图片管理</h2>
    <div class="form-row">
      <p class="tip-text">当前图片：</p>
      <img v-if="imgUrl" :src="imgUrl" class="preview-img" />
      <span v-else>暂无图片</span>
    </div>
    <div class="form-row">
      <p class="tip-text">图片文字介绍：</p>
      <textarea v-model="form.intro" rows="4" style="width:100%;padding:8px;" placeholder="在这里填写图片介绍文字，不填写则小程序不展示"></textarea>
    </div>
    <div class="form-row">
      <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" />
    </div>
    <!-- Vue用v-show控制显示隐藏，替代原生style.display -->
    <div v-show="showTip" style="color:#ff7d00;margin:10px 0;font-size:14px;">⚠️ 已选中图片，请点击【保存】按钮完成保存！</div>
    <div class="form-row">
      <button class="btn-upload" @click="submitUpload">保存</button>
    </div>
  </div>
</template>
<script>
// 删掉 import axios from 'axios'，不再使用原生axios
import { getImageUrl } from '@/config.js'
export default {
  name: "ImageManage",
  data() {
    return {
      imgUrl: '',
      showTip: false,
      rawFile: null, // 必须加上，存选中图片文件
      form: {
        intro: '' //新增介绍字段
      }
    }
  },
  mounted() {
    this.loadCurrentImage();
  },
  methods: {
    // 读取已保存图片+文字介绍
    async loadCurrentImage() {
      // 使用 $request，自动带上Authorization token
      const res = await this.$request.post("action.php", "act=getSingleImage", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      if(res.code === 200 && res.data){
        this.imgUrl = getImageUrl(res.data.img_url)
        this.form.intro = res.data.intro || ''
      }
    },
    // 选择图片，本地预览 + 打开提示
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) {
        this.showTip = false;
        return;
      }
      this.rawFile = file;
      this.showTip = true; // 选中图片，展示橙色提示
      const reader = new FileReader();
      reader.onload = (res) => {
        this.imgUrl = res.target.result;
      };
      reader.readAsDataURL(file);
    },
    // 提交保存：支持【只保存文字】或者【图片+文字一起保存】
    async submitUpload() {
      const formData = new FormData()
      formData.append('act', 'saveSiteImg')
      formData.append('intro', this.form.intro) // 把文字介绍提交后端

      // 只有选中新图片，才追加图片文件
      if(this.rawFile){
        formData.append('imgfile', this.rawFile)
      }

      // 文件上传，$request自动携带token
      const res = await this.$request.post("action.php", formData)
      if(res.code === 200){
        alert("保存成功！")
        this.rawFile = null
        this.$refs.fileInput.value = ""
        this.showTip = false; // ✅保存成功，隐藏提示文字
        this.loadCurrentImage(); // 保存完成，重新拉取最新数据刷新页面
      }else{
        alert(res.msg)
      }
    }
  }
};
</script>
<style scoped>
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px;
}
.card h2 {
  font-size: 28px;
  color: #111;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}
.form-row {
  margin-bottom: 20px;
}
.tip-text {
  margin-bottom:12px;
  font-size:16px;
  color:#444;
}
.preview-img {
  max-width: 300px;
  border-radius: 6px;
  border: 1px solid #eee;
}
.btn-upload{
  background:#409eff;
  color:#fff;
  border:none;
  padding:8px 18px;
  border-radius:4px;
  cursor:pointer;
}
</style>
